<template>
  <el-table
    size="mini"
    ref="mytable"
    :data="tableDataBase"
    height="calc(100% - 392.22px)"
    style="width: 100%"
    class="table"
    border
  >
    <el-table-column type="index" width="100" label="序号"></el-table-column>
    <el-table-column prop="institutionName" label="企业名称" width="250"></el-table-column>
    <el-table-column prop="reportTitle" label="季报" width="250"></el-table-column>
    <el-table-column prop="submitTime" label="报送时间" width="250"></el-table-column>
    <el-table-column prop="status" label="状态" width="80">
      <template slot-scope="scope">
        <el-tag :type="getTagName(scope.row.reportState)[0]">{{ getTagName(scope.row.reportState)[1] }}</el-tag>
      </template>
    </el-table-column>
    <el-table-column prop="status" label="季报类型" width="380">
      <template slot-scope="scope">
        <el-popover placement="left" title="警告" width="200" trigger="hover">
          <span>
            <i style="color: #ff3333" class="el-icon-info"></i>
            变更季报类型将清空已填季报内容，需重新填写！
          </span>
          <el-select size="mini" slot="reference" v-model="scope.row.reportFillType">
            <el-option
              v-for="(item, index) in options"
              :value="item.value"
              :label="item.label"
              :key="index"
            ></el-option>
          </el-select>
        </el-popover>
        <el-button
          style="margin-left: 10px"
          v-show="tableData[scope.$index].reportFillType != scope.row.reportFillType"
          type="text"
          size="small"
          @click="changeReportFill(scope.row)"
        >
          确认
        </el-button>
        <el-button
          @click="scope.row.reportFillType = tableData[scope.$index].reportFillType"
          v-show="tableData[scope.$index].reportFillType != scope.row.reportFillType"
          type="text"
          size="small"
        >
          取消
        </el-button>
      </template>
    </el-table-column>
    <el-table-column label="操作" fixed="right" min-width="240">
      <template slot-scope="scope">
        <div v-if="scope.row.reportFillType">
          <el-button
            v-if="[1, 3, 2, 4, 5].includes(scope.row.reportState)"
            type="text"
            size="small"
            @click="toDetail(scope)"
          >
            导出季报文件
          </el-button>
          <el-button
            v-if="
              [1, 3, 2, 4, 5].includes(scope.row.reportState) &&
              scope.row.detailDataFileStorePath &&
              scope.row.detailDataFileStorePath != ''
            "
            type="text"
            size="small"
            @click="toDetailGZ(scope)"
          >
            下载盖章文件
          </el-button>
          <!--  <el-button
          type="text"
          size="small"
          v-if="[3].includes(scope.row.reportState)"
          @click="fillReport(scope)"
          >补报</el-button
        >-->
          <el-button
            type="text"
            size="small"
            v-if="[0, 3].includes(scope.row.reportState) && ['x', 'y'].includes(scope.row.reportFillType)"
            @click="fillReport(scope)"
            >填写季报</el-button
          >
          <div v-if="[1].includes(scope.row.reportState)" class="editCls">
            <!-- <el-button type="text" size="small" @click.stop.native="toDetail(scope)">详情</el-button> -->
            <el-button type="text" size="small" @click="fillReport(scope)">编辑</el-button>
          </div>
          <el-button
            type="text"
            size="small"
            v-if="
              [0, 1, 3].includes(scope.row.reportState) && ['zq', 'gq', 'x', 'y'].includes(scope.row.reportFillType)
            "
            @click="fillReportExcel(scope)"
            >直接上传</el-button
          >
          <el-button
            type="text"
            size="small"
            v-if="
              [0, 1, 3].includes(scope.row.reportState) && ['zq', 'gq', 'x', 'y'].includes(scope.row.reportFillType)
            "
            @click="dataSourceTemplate(scope.row.reportFillType)"
            >模板下载</el-button
          >
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
const statusMap = {
  0: 'warning/未填报',
  1: 'warning/已保存',
  2: 'success/已提交',
  3: 'warning/逾期未报',
  4: 'success/已补报',
  5: 'success/已反馈'
}
import { reportExport, commonDownload, updateReportCheckRecord, dataSourceTemplate } from 'common/js/api'
export default {
  props: ['tableData', 'type'],
  data() {
    return {
      options: [
        {
          label: '湖南证监局-股权',
          value: 'gq'
        },
        {
          label: '湖南证监局-证券',
          value: 'zq'
        },
        {
          label: '小镇-管理人',
          value: 'x'
        },
        {
          label: '小镇-基金',
          value: 'y'
        }
      ],
      tableDataBase: []
    }
  },
  methods: {
    getTagName(status) {
      return statusMap[status].split('/')
    },

    async toDetail(scope) {
      await reportExport(scope.row.reportCode)
    },
    async toDetailGZ(scope) {
      let params = {
        fileName: scope.row.detailDataFileOrginName,
        filePath: scope.row.detailDataFileStorePath
      }
      await commonDownload(params)
    },
    fillReportExcel(scope) {
      const codeId = scope.row.reportCode
      let path
      //--gq股权  --zq证券   --x未管  --y未基
      if (scope.row.reportFillType == 'gq') {
        path = '/QuaReport/MgrGQ'
        this.$router.push({
          path,
          query: {
            codeId,
            step: 0,
            excel: 1,
            reportName: scope.row.reportTitle,
            institutionCode: scope.row.institutionCode,
            reportFillType: scope.row.reportFillType
          }
        })
      } else if (scope.row.reportFillType == 'zq') {
        path = '/QuaReport/MgrGQ'
        this.$router.push({
          path,
          query: {
            codeId,
            step: 0,
            excel: 1,
            reportName: scope.row.reportTitle,
            institutionCode: scope.row.institutionCode,
            reportFillType: scope.row.reportFillType
          }
        })
      } else if (scope.row.reportFillType == 'x') {
        path = '/QuaReport/AgencyMan'
        this.$router.push({
          path,
          query: {
            codeId,
            step: 4,
            excel: 1,
            reportName: scope.row.reportTitle,
            institutionCode: scope.row.institutionCode,
            reportFillType: scope.row.reportFillType
          }
        })
      } else if (scope.row.reportFillType == 'y') {
        path = '/QuaReport/AgencyMan'
        this.$router.push({
          path,
          query: {
            codeId,
            step: 4,
            excel: 1,
            reportName: scope.row.reportTitle,
            institutionCode: scope.row.institutionCode,
            reportFillType: scope.row.reportFillType
          }
        })
      } else {
        console.log('/QuaReport/recordTable is error', scope.row.reportFillType)
      }
    },
    fillReport(scope) {
      const codeId = scope.row.reportCode
      let path
      //--gq股权  --zq证券   --x未管  --y未基
      if (scope.row.reportFillType == 'gq') {
        path = '/QuaReport/MgrGQ'
      } else if (scope.row.reportFillType == 'zq') {
        path = '/QuaReport/MgrGQ'
      } else if (scope.row.reportFillType == 'x') {
        path = '/QuaReport/AgencyMan'
      } else if (scope.row.reportFillType == 'y') {
        path = '/QuaReport/AgencyMan'
      } else {
        console.log('/QuaReport/recordTable is error', scope.row.reportFillType)
      }
      // this.type == "gq" ? "/QuaReport/MgrGQ" : "/QuaReport/Agency";
      // const path = "";

      console.log('/QuaReport/recordTable', scope)

      this.$router.push({
        path,
        query: {
          codeId,
          reportName: scope.row.reportTitle,
          institutionCode: scope.row.institutionCode,
          reportFillType: scope.row.reportFillType,
          institutionName: scope.row.institutionName
        }
      })
    },
    async changeReportFill(row) {
      console.log(row)
      const res = await updateReportCheckRecord(row)
      if (res.code == 200) {
        this.$emit('changeReportFill')
      } else {
        this.$message.error('变更失败')
      }
    },
    async dataSourceTemplate(reportFillType) {
      await dataSourceTemplate(reportFillType)
    }
  },
  watch: {
    tableData: {
      handler(newVal) {
        this.tableDataBase = JSON.parse(JSON.stringify(newVal))
      },
      immediate: true,
      deep: true
    },
    tableDataBase() {
      let a = () => {
        this.$refs.mytable.doLayout()
      }
      this.$nextTick(a)
    }
  }
}
</script>

<style scoped>
.table {
  margin-top: 20px;
}
.editCls {
  display: inline-block;
}
.el-table >>> .is-scrolling-right::-webkit-scrollbar {
  width: 0 !important;
}
</style>
